import { api } from "./api";
import type { PriceObservation } from "../types/receipt";

/**
 * Share concurrent reads, never a completed snapshot. Another device or assistant may have
 * changed prices since the last screen opened. `fresh` bypasses even an in-flight read after a
 * save or before an edit, when that earlier request may have started before the mutation.
 */
let shared: Promise<PriceObservation[]> | null = null;

export function loadPriceList(fresh = false): Promise<PriceObservation[]> {
  if (fresh || !shared) {
    const request = api<{ observations?: PriceObservation[] }>("prices").then(
      (r) => r.observations || [],
    );
    shared = request;
    const clear = () => {
      // An older request completing must not clear a newer forced refresh.
      if (shared === request) shared = null;
    };
    void request.then(clear, clear);
  }
  return shared;
}
